module.exports = __webpack_public_path__ + "static/media/49.58ed5959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/49.jpg
// module id = 582
// module chunks = 0